import Modal from '@/components/ui/modal/index.vue';
import { reactive, watch, ref, watchEffect, getCurrentInstance, computed, } from 'vue';
import { useStore } from 'vuex';
import { POPUP, BTN, CHECKING_STATUS, FEATURENAME, ACTIONBAR, LANG, ERRORDESC, BRAND } from '@/enum/enum';
import { uuid } from 'vue-uuid';
import { btnDefault, btnBorderMainStyleFull, btnMainStyleEnable, btnMainStyleFull, btnBorderMainStyleEnable } from './btnUtils';
import Input from '@/components/ui/input/index.vue';
import Checkbox from '@/components/ui/checkbox/index.vue';
import Textarea from '@/components/ui/textarea/index.vue';
import Select from '@/components/ui/select/index.vue';
import Table from '@/components/ui/tablebox/index.vue';
import Tab from '@/components/ui/tab/index.vue';
import Button from '@/components/ui/button/index.vue';
import Radio from '@/components/ui/radio/index.vue';
import Slidebar from '@/components/ui/slidebar/index.vue';
import Cardimg from '@/components/ui/cardimg/index.vue';
import { apiGetTasks, apiAgree, apiETTasksList, apiGetGroupModel, apiGetDevice, apiContact, apiInvitations, apiCSVUpload, apiDeviceAdd, apiSetTargetList, apiLogout, apiEULA, apiMe } from '@/api/api';
import Timer from '@/components/ui/timer/index.vue';
import { sortByKey } from '@/utils/utils';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import {EULA} from '@/assets/lang-template/EULA/EULA';

import { webLicense, pcLicense } from '@/assets/data/license';
import { CONIFG } from '@/config';
export default {
  components: {
    Modal,
    Input,
    Checkbox,
    Textarea,
    Select,
    Table,
    Tab,
    Button,
    Radio,
    Slidebar,
    Cardimg,
    Timer,
  },
  props: {},
  setup() {
    const store = useStore();
    const storeState = store.state;
    const {proxy} = getCurrentInstance();
    const router = useRouter();
    const {t, locale} = useI18n();
    const brand = computed(() => store.state.brand);

    const state = reactive({
      isOpenModal: false,
      type: POPUP.AGREEMENT,
      data: null,
      title: 'modal title',
      subTitle: 'modal subTitle',
      content: 'modal content',
      testName: '', // temp for test
      customized: [],
      save_customized_name: '',
      save_customized_error: false,
      istrue: true,
    });
    const calibration_data = reactive({
      group: {
        text: t('__common.__all'),
        val: 'All',
      },
      device: {
        text: t('__d7d_n17r.__allDevices'),
        val: 'All',
      },
      order: 'asc', //asc,desc
      sort: 'model',
      per_page: 99999999,
      devices: [],
      isGroup: {
        text: 'All',
        val: 'All',
      },
      defaultCheck: [],
    });

    const addDeviceBtnText = computed(() => {
      return t('__common.__add');
    });
    const groupVal = reactive({
      groupName: '', //新增或修改群組的名稱
      isGroupNameError: undefined, //名稱的input錯誤內容提示
      compareNameList: {}, //比較錯誤的範例
      selectVal1: {
        text: '',
        val: '',
      }, //新增裝置到群組中的下拉選單一
      selectVal2: {
        text: t('__d7d_n17r.__allDevices'),
        val: '',
        isI18n: '__d7d_n17r.__allDevices',
      }, //新增裝置到群組中的下拉選單二
      selectList: [], //打勾被選的table row
      // tempSelectName: '', //下拉選單一
      sort: {}, //table 排序相關
      addDeviceBtnText: addDeviceBtnText.value,
    });
    const brandDisplayTxt = brand.value == BRAND.ASUS ? '' : 'ProArt';

    const __popup = reactive({
      __asusPrivacyNoticeTitle: 'ASUS NOTICE',
      __asusPrivacyNoticeTitleDesc1: `Welcome to use ASUS ${brandDisplayTxt} Color Center website ("this Website")!`,
      __asusPrivacyNoticeTitleDesc2: 'Please find the below details of ASUS Privacy Notice (Part 1) and ASUS EU Data Act Notice (Part 2):',
      __asusPrivacyNoticePart1Title: 'Part 1: ASUS Privacy Notice',
      __asusPrivacyNoticePoint1_text: `1. In order to remotely manage, adjust and control the color of ASUS ${brandDisplayTxt} monitors ("Monitor"), assess and improve ASUS products and services, and to develop and evaluate new products and services of ASUS, by clicking on "I agree" below, you agree to provide the following information with ASUS:`,
      __asusPrivacyNoticePoint1_data: 'Serial number of Monitor; calibration history, settings and management information of Monitor, such as group name, calibration schedule, standard of color space, color gamut, brightness, color temperature, EOTF (Electro-Optical Transfer Function) and type of external calibration unit.',
      __asusPrivacyNoticePoint1_note: 'Please note that: The above data is necessary for ASUS to provide you with the functions of remote management, adjustment and control for the color of Monitor. If you click on "I do not agree" button below or disable sharing the above data with ASUS through the route mentioned in the 4ᵗʰ paragraph, this Website may not work normally. We apologize for the inconvenience this may cause.',
      __asusPrivacyNoticePoint2_text: '2. To use the remote service, you need to bind your user account of this Website with a Monitor. You may access to the product and log information of the Monitor, and proceed with color calibration on it. If the user of Monitor does not agree to share data with you, please do not start with the binding process. Please refer to the user manual to see the details of account binding.',
      __asusPrivacyNoticePoint3_title: '3. Member registration:',
      __asusPrivacyNoticePoint3_text: 'Before you start to use this Website, please register and login to ASUS/ ROG Account. Regarding how to register for an ASUS/ ROG Account, please refer to the registration interface or website of ASUS/ ROG Account.',
      __asusPrivacyNoticePoint4_text: '4. ASUS is committed to protecting and respecting your privacy; you may visit Information> Privacy to enable/disable sharing the above with ASUS at all times. To know more about how ASUS protects your privacy, please visit',
      __asusPrivacyNoticePoint4_link: 'ASUS\' Privacy Policy/ ASUS EU Data Act Policy.',

      __asusEUDataActNoticePart2Title: 'Part 2: ASUS EU Data Act Notice (For EU products)',
      __asusEUDataActNoticeIntro: 'During your use of this Software, your data ("Product Data") in connection with this ASUS Monitor ("Connected Product") governed by the EU Data Act may be generated. As required under Article 3 (2) of EU Data Act, please refer to the details below about your Product Data:',
      __asusEUDataActNoticePoint1_title: '1.	Information about type, format and estimated volume of Product Data: ',
      __asusEUDataActNoticePoint1_1: '(1)	The Connected Product generates the following type(s) of the Product Data: Data mentioned in Paragraph 1 in the above Part 1 ASUS Privacy Notice',
      __asusEUDataActNoticePoint1_2: '(2)	Product Data is available in the following format(s): csv',
      __asusEUDataActNoticePoint1_3: '(3)	Estimated volume of the Product Data: 100 bytes/ per data ',
      __asusEUDataActNoticePoint2_title: '2.	Information about whether the Connected Product is capable of generating the Product Data continuously and in real-time: Yes',
      __asusEUDataActNoticePoint3_title: '3.	Information about whether the Connected Product is capable of storing the Product Data on-device or on a remote server, including, where applicable, the intended duration of retention: ',
      __asusEUDataActNoticePoint3_1: '(1)	The Connected Product is capable of storing the Product Data on server. ',
      __asusEUDataActNoticePoint3_2: '(2)	Product Data is stored until you instruct us to delete it. ',
      __asusEUDataActNoticePoint4_title: '4.	Information about how the user may access, retrieve or, where relevant, erase the Product Data, including the technical means to do so, as well as their terms of use and quality of service: ',
      __asusEUDataActNoticePoint4_1_pre: '',
      __asusEUDataActNoticePoint4_1_link_text: '',
      __asusEUDataActNoticePoint4_1_post: '',

      // end: todo 沒有放在string table裏
      __endUserLicenseAgreement: 'End User License Agreement',
      __eULAArticle1: 'This End User License Agreement ("EULA") constitutes a valid and binding agreement between ASUSTeK Computer Inc. ("ASUS") and You, as a user, for the use of the ASUS Software ("Software") defined as set forth below. By installing and continuing to use the software YOU EXPRESSLY ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND AND AGREE TO BE BOUND BY THE TERMS OF THIS EULA AND ANY NEW VERSIONS HEREOF.',
      __software: 'SOFTWARE',
      __eULAArticle2: 'means the ASUS Software provided in or with the applicable ASUS product including but not limited to any future programming fixes, updates, upgrades and modified versions.',
      __eULAArticle3: 'The Software may be accompanied by other ASUS- or third party created software that is licensed under one or more of the Free Open Source Software licenses as listed under www.opensource.org/licenses. Such Free Open Source Software is provided to you solely under the terms of the respective license agreement or copyright notice accompanying it or in the FOSS licenses file accompanying the Software. The terms of this EULA do NOT apply to such Free Open Source Software.',
      __eULAArticle4: 'LICENSE Subject to the terms of this EULA, ASUS hereby grants You a limited, personal, non-commercial, non-exclusive license to use the Software solely as embedded in the ASUS products. You may make one copy of the Software in machine-readable form for backup purposes only; provided that the backup copy must include all copyright or other proprietary notices contained on the original. This license shall not be sublicensed, and is not transferable except to a person or entity to whom you transfer ownership of the complete ASUS products containing the Software, provided you permanently transfer all rights under this EULA and do not retain any full or partial copies of the Software, and the recipient agrees to the terms of this EULA.',
      __eULAArticle5: 'REVERSE RESTRICTION You shall not reverse engineer, decompile decrypt or disassemble the Software or permit or induce the foregoing except to the extent directly applicable law prohibits enforcement of the foregoing.',
      __eULAArticle6: 'CONFIDENTIAL ITY You shall have a duty to protect and not to disclose or cause to be disclosed in whole or in part of confidential information of the Software including but not limited to trade secrets, copyrighted material in any form to any third party.',
      __eULAArticle7: 'Intellectual Property RIGHTS ("IP Rights") You acknowledge and agree that all IP Rights, title, and interest to or arising from the Software are and shall remain the exclusive property of ASUS or its licensor. Nothing in this EULA intends to transfer any such IP Rights to You. Any unauthorized use of the IP Rights is a violation of this EULA as well as a violation of intellectual property laws, including but not limited to copyright laws and trademark laws. By sending any information, material, ideas, concepts or techniques except for personal information to ASUS through the Software ("Feedbacks"), You acknowledge and agree that: (i) Your Feedbacks shall not contain confidential or proprietary information; (ii) ASUS is under no obligation of any kind of confidentiality, express or implied, regarding the Feedbacks; (iii)ASUS shall be entitled to use or disclose, at ASUS\'s sole discretion, the Feedbacks for any purpose, in any way, worldwide; (iv) Your Feedbacks shall become the property of ASUS without any obligation of ASUS to You; and (v) You are not entitled to any compensation or reimbursement of any kind from.',
      __eULAArticle8: 'TERM AND TERMINATION This EULA will be effective as of the date You install the Software. You may terminate this License at any time by ceasing all use of the Software and removing the Software from ASUS product. Your right will terminate without prior notice from ASUS if we think You fail to comply with any provision of this EULA.',
      __eULAArticle9: 'Warranty Disclaimer and Limitation of Liability YOU ACKNOWLEDGE THAT THE SOFTWARE IS PROVIDED "AS IS." THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THIS SOFTWARE IS WITH YOU, INCLUDING BUT NOT LIMITED TO RELATED COST OF ALL NECESSARY SERVICING AND REPAIR. TO THE EXTENT PERMITTED BY LAW, ASUS MAKES NO WARRANTIES, EXPRESS OR IMPLIED, WITH RESPECT TO THIS SOFTWARE OR ANY OTHER INFORMATION OR DOCUMENTATION PROVIDED UNDER THIS EULA OR FOR THIS SOFTWARE, INCLUDING BUT NOT LIMITED TO ANY WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OR AGAINST INFRINGEMENT, OR ANY WARRANTY ARISING OUT OF USAGE OR OUT OF COURSE OF PERFORMANCE. ASUS ALSO MAKES NO WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THIS SOFTWARE OR AS TO THE ACCURACY OR RELIABILITY OF ANY INFORMATION OBTAINED THROUGH THIS SOFTWARE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR CERTAIN DAMAGES. ACCORDINGLY, SOME OF THE ABOVE DISCLAIMERS AND LIMITATIONS OF LIABILITY MAY NOT APPLY TO YOU.',
      __eULAArticle10: 'THE ENTIRE RISK ARISING OUT OF THE USE AND/OR PERFORMANCE OF THIS SOFTWARE REMAINS WITH YOU. IN NO EVENT SHALL ASUS, ITS LICENSORS OR ANY OF THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS OR AFFILIATES BE LIABLE FOR ANY CONSEQUENTIAL, INCIDENTAL, DIRECT, INDIRECT, SPECIAL, PUNITIVE, OR OTHER DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, INTERRUPTION, LOSS OF INFORMATION, OR OTHER PECUNIARY LOSS) ARISING OUT OF OR RELATING TO THIS EULA OR THE USE OF OR INABILITY TO USE THE SOFTWARE OR ANY PART THEREOF, EVEN IF ASUS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR CERTAIN DAMAGES. ACCORDINGLY, SOME OF THE ABOVE DISCLAIMERS AND LIMITATIONS OF LIABILITY MAY NOT APPLY TO YOU.',
      __eULAArticle11:
        'Indemnity YOU agree to defend, indemnify and hold harmless ASUS and its affiliates, service providers, syndicators, distributors, licensors, officers, directors and employees, from and against any and all losses, damages, liabilities, and expenses arising out of any claim or demand (including reasonable attorneys\' fees and court costs), due to or in connection with YOUR violation of this EULA or any applicable law or regulation, or third-party right.',
      __EULA: EULA.EN,
    });

    // 聯絡我們
    store.watch(
      (state) => state.userInfo.email,
      (val) => {
        console.log('watch mail', val, store.getters.getUserEmail);
        contactModal.mail = val;
      }
    );
    const contactModal = reactive({
      btnDisable: false,
      mail: store.getters.getUserEmail,
      region: '',
      msg: '',
      isCheck: false,
      isMailError: false,
      isRegionError: false,
      isMsgError: false,
      isCheckError: false,
    });

    const checkContactValid = () => {
      contactModal.isMailError = contactModal.mail === '';
      contactModal.isRegionError = contactModal.region === '';
      contactModal.isMsgError = contactModal.msg === '';
      contactModal.isCheckError = !contactModal.isCheck;
      const isError =
        contactModal.isMailError ||
        contactModal.isRegionError ||
        contactModal.isMsgError ||
        contactModal.isCheckError;
      console.log('isError', isError);

      return !isError;
    }; //end: checkContactValid

    // contactus modal
    const submitContactus = async () => {
      console.log('submitContactus');
      const isValid = checkContactValid();
      if (isValid) {
        console.log('ok valid');
        try {
          const data = {
            subject: `${contactModal.region}/${contactModal.mail}`,
            content: contactModal.msg,
          };
          await apiContact(data);
        } catch (err) {
          console.warn('apiContact error', err.response);
        } //end: catch
        submitModal(contactModal);
        cleanContactForm();

        // submitModal(contactModal);
      } //end: if
    }; //end:submitContactus

    const cleanContactForm = () => {
      contactModal.mail = store.getters.getUserEmail;
      contactModal.region = '';
      contactModal.msg = '';
      contactModal.isCheck = false;
    }; // end: cleanContactForm

    store.watch(
      (state) => (state.isShowModal, state.modalType),
      () => {
        // console.log('watch')
        state.type = storeState.modalType;
        state.data = storeState.modalData;
        handleModalContent(state.type, state.data);
        setTimeout(() => {
          state.isOpenModal = storeState.isShowModal;
        }, 50);
      }
    );
    /**
     * 處理modal裡面的內容
     * @param modalType
     * @param modalData
     */
    const handleModalContent = (modalType, modalData) => {
      const _data = modalData;
      const _type = modalType;

      if (_type === 1) {
        //lynn
        const {title, content} = _data;
        state.title = title;
        state.content = content;
      } //end: if
    }; //end: handleModalContent;

    /**
     * 通用點擊關閉按鈕 modal
     */
    const closeModal = (btnType = BTN.CANCEL) => {
      const _btnType = btnType + uuid.v1();
      console.log('btnType', _btnType);
      store.commit('setModalBtnType', _btnType);
      store.commit('setCloseModal');
    };

    /**
     * 通用點擊送出 modal
     * @param val 要傳出去的值
     * @param isClose 按完按鈕是否要關掉modal
     */
    const submitModal = (val, isClose = true) => {
      store.commit('setModalOutput', val);
      console.log('submitModal', val);
      if (isClose) {
        closeModal(BTN.CONFIRM);
      }
    }; //end: submitModal

    // demo popup
    const cancelTestModal = () => {
      state.testName = '';
      closeModal();
    };

    // demo confirm  - submit modal
    const sumbitTestModal = (val) => {
      state.testName = '';
      submitModal(val);
    }; //end: submtTestModal

    // POPUP.PRIVACY
    const onPrivacySumbit = async (isAgree) => {
      const _isAgree = isAgree;
      console.log('onPrivacySumbit isAgree', _isAgree);

      if (_isAgree) {
        try {
          const config = {
            version: CONIFG.policy_version,
            label: window.location.href,
          };
          await apiAgree(config);

          //check is show eula
          try {
            await apiMe();
            const str = storeState.modalType;
            const isShowEULA = str.indexOf('header') == -1;
            if (isShowEULA) {
              const modalConfig = {
                type: POPUP.AGREEMENT + uuid.v4(),
                data: [],
                isShow: true,
              };
              store.commit('setIsShowModal', modalConfig);
            } //end: if
          } catch (err) {
            console.log('err apiMe err');
          } //end: catch
        } catch (err) {
          console.log('err apiAgree err');
        } //end: cstch
      } //end: if
      else {
        // disagree logout
        try {
          const config = {
            version: '0',
            label: window.location.href,
          };
          await apiAgree(config);
        } catch (err) {
          console.log('err apiAgree err');
        } //end: cstch
        onLogout();
      } //end: else
    }; //end: onPrivacySumbit

    // todo change link when lang chnage

    const privacyLink = ref(
      'https://www.asus.com/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy/'
    );
    watch(
      () => locale.value,
      (val) => {
        console.log('lange locale change val', val);
        _changePrivacyLink(val);
        _changePrvacyTxt(val);
      }
    ); //end: watch

    const _changePrivacyLink = (lang) => {
      const _lang = lang;

      switch (_lang) {
        case LANG.EN:
          privacyLink.value =
            'https://www.asus.com/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy/';
          break;
        case LANG.TW:
          privacyLink.value =
            'http://www.asus.com/tw/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy';
          break;
        default:
          privacyLink.value =
            'https://www.asus.com/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy/';
          break;
      } //end: switdh
    }; //end: _changePrivacyLink

    // logout
    const onLogout = async () => {
      try {
        await apiLogout();
        router.push({name: FEATURENAME.LOGIN});
      } catch (err) {
        console.warn('apiLogout error', err);
      }
    }; //end: logout

    // POPUP.AGREEMENT (EULA)
    const onEULAubmit = async () => {
      console.log('onEULAubmit');
      try {
        const config = {
          agreement: true,
          label: window.location.href,
        };
        await apiEULA(config);
      } catch (err) {
        console.log('err apiEULA err');
      } //end: cstch
    };

    //deivce device

    const resetProfile = () => {
      store.commit('setModalOutput', state.data.list);
      closeModal(BTN.CONFIRM);
    };

    const tableFilter = () => {
      store.commit('setModalOutput', state.data.list);
      closeModal(BTN.CONFIRM);
    };

    const groupError = () => {
      store.commit('setModalOutput', state.data.actionFlag);
      closeModal(BTN.CONFIRM);
    };

    //group group

    watch(
      () => state.type,
      (val) => {
        if (val == POPUP.GROUPADD || val == POPUP.MODIFYGROUP) {
          apiAllNameList();
        }
      }
    );

    watch(
      () => state.data,
      (val) => {
        state.data = val;
        // console.log('default model', state/.data.defaultModel)
        if (state.data.defaultModel || state.data.defaultModel == ' ') {
          console.log('no default model');
          groupVal.selectVal1 = {
            text: state.data.defaultModel,
            val: state.data.defaultModel,
          };
        }
      },
      {deep: true}
    );

    watch(
      () => groupVal.selectList,
      (val) => {
        if (val) {
          //Add BTN 數量變化
          groupVal.addDeviceBtnText = `${addDeviceBtnText.value}(${val.length})`;
        }
      },
      {deep: true}
    );

    const subGroupAdd = (val) => {
      if (!val) {
        if (state.type == POPUP.MODIFYGROUP) {
          // val = state.data.groupName
          groupVal.isGroupNameError = t(
            '__g3p_m8t.__thereIsAlreadyAGroupWithTheSameName'
          );
          return;
        } else if (state.type == POPUP.GROUPADD) {
          val = `${t('__g3p_m8t.__newGroup')} ${state.data.totalLength + 1}`;
        }
      } else {
        // console.log(val, 'valllll')
        // console.log(groupVal.compareNameList['groups'], 'compareNameList')
        if (groupVal.compareNameList['groups'].length) {
          // console.log(groupVal.compareNameList['groups'].length, 'val2222222')
          for (let i = 0; i < groupVal.compareNameList['groups'].length; i++) {
            // console.log('hhhhh...', groupVal.compareNameList['groups'][i])
            if (val == groupVal.compareNameList['groups'][i].name) {
              groupVal.isGroupNameError = t(
                '__g3p_m8t.__thereIsAlreadyAGroupWithTheSameName'
              );
              return;
            }
          }
        }
      }

      submitModal(val); ///api 先判斷
      setTimeout(() => {
        groupVal.groupName = '';
        groupVal.isGroupNameError = undefined;
      }, 1000);
    };

    const transferDepictionCodeForMessage = (errorcode, valText) => {
      if (errorcode[valText]) {
        return t(errorcode[valText]);
      } else {
        return t(errorcode[100]);
      }
    };

    const apiAllNameList = async () => {
      try {
        const datas = await apiGetGroupModel();
        console.log('compare apiGetGroupModel', datas);
        if (!datas.status_code) {
          groupVal.compareNameList = datas;
        }
      } catch (error) {
        return error;
      }
    };

    // const apiAllNameList = async () => {
    //   let max = Number.MAX_SAFE_INTEGER
    //   const sendData = {
    //     page: max,
    //   }
    //   try {
    //     const datas = await apiGroup(sendData);
    //     console.log('compare apiGroup', datas)
    //     if (!datas.status_code) {
    //       groupVal.compareNameList = datas;
    //     }
    //   }
    //   catch (error) {
    //     return error;
    //   }
    // }

    const addDeviceToGroup = () => {
      submitModal(groupVal.selectList);
      groupVal.selectList = [];
    };

    const groupNameClose = () => {
      groupVal.groupName = '';
      groupVal.isGroupNameError = undefined;
      closeModal();
    };

    const unGroup = () => {
      const arr = [];
      for (let i = 0; i < state.data.list.length; i++) {
        arr.push(state.data.list[i].id);
      }
      // console.log(arr,'un group list')
      submitModal({arr, action: state.data.action});
    };

    const tableSortDevi = (v) => {
      // console.log(v, 'sort table')
      getTasks(v);
    };

    const tableSortDeviceAdd = (v) => {
      groupVal.sort = v;
      console.log(groupVal.sort);
      modalDeviceList();
    };

    const editApp = (text, data) => {
      console.log(data);
      if (text && !data.deleted) {
        window.open(text);
      }
    };

    const selectChange = () => {
      state.data.selectDisable = false;
      modalDeviceList();
    };

    const modalDeviceList = async () => {
      const maxNum = Number.MAX_SAFE_INTEGER;
      const sendData = {
        per_page: maxNum,
        order: groupVal.sort['val'] === 'up' ? 'asc' : 'desc',
        sort: groupVal.sort['key'],
        status: groupVal.selectVal2['val'],
        model:
          groupVal.selectVal1['val'] == ' '
            ? undefined
            : groupVal.selectVal1['val'],
      };

      console.log('sendData', sendData);
      try {
        const datas = await apiGetDevice(sendData);
        state.data.list = datas.data;
        state.data.list = state.data.list.filter((e) => {
          //model 為null的話不顯示
          return e.model;
        });
        state.data.list = state.data.list.filter((e) => {
          //model 狀態為waiting的話不顯示
          return e.status != 2;
        });
        console.log('compareList', state.data.compareList);
        state.data.list = state.data.list.filter((e) => {
          //device已存在的話不顯示
          console.log(e.id, state.data.compareList.indexOf(e.id) < 0);
          return state.data.compareList.indexOf(e.id) < 0;
        });
        state.data.defaultModel = groupVal.selectVal1['val'];
        console.log('跳窗裡面', state.data.list);
      } catch (error) {
        return error;
      }
    };

    const getTasks = async (v) => {
      console.log(v, 'ooo');
      const id = state.data.id;
      const sendData = {
        sort: v.key,
        order: v.val === 'up' ? 'asc' : 'desc',
      };
      try {
        const datas = await apiETTasksList(id, sendData);
        console.log('MSG apiGetTasks', datas);

        const temp = datas.tasks;

        for (let i = 0; i < temp.length; i++) {
          temp[i].newStatus = null;
          if (temp[i].deleted) {
            temp[i].newStatus = 4;
          } else {
            if (temp[i].status == 0) {
              temp[i].newStatus = 999;
            } else {
              temp[i].newStatus = temp[i].status;
            }
          }
        } //depiction_code

        state.data.list = temp;
      } catch (error) {
        return error;
      }
    };

    const onCheckAllDevi = (v) => {
      console.log(v, 'table onCheck All');
      groupVal.selectList = v;
    };

    const onCheckEachDevi = (v) => {
      console.log(v, 'table onCheck Each');
      groupVal.selectList = v;
    };

    const goTableLinkDevi = (v) => {
      console.log(v, 'table link');
    };

    const showCTAndRowDevi = (v) => {
      console.log(v, 'showCTAndRowDevi');
    };

    // -  global add device

    const globalAddDeviceModal = reactive({
      tabText: [
        {
          name: 'Upload Device List (CSV)',
          val: 'tab1',
          disabled: false,
          alertText: '',
          isI18n: '__popup.__uploadDeviceListCsv',
          gtmId: '__uploadDeviceListCsv',
        },
        {
          name: 'Send Invitation Code',
          val: 'tab2',
          disabled: false,
          alertText: '',
          isI18n: '__popup.__sendInvitationCode',
          gtmId: '__sendInvitationCode',
        },
      ],
      activeTabIndex: 0,
      btnConfirm: btnBorderMainStyleFull('Download Sample'),
      btnCancel: btnMainStyleFull('Upload CSV'),
      isStart: false,
      time: -1, // init time
      expireTime: 0,
      code: '-',
      isShowCode: false, // diplay intro or code
      btnCodeDisable: false,
      btnGenerateDisable: false, // button status disable or not
    });

    const onClickGlobalDeviceTab = (val) => {
      const _activeTab = val.index;
      globalAddDeviceModal.activeTabIndex = _activeTab;
    };

    // global add device tab watch
    watch(
      () => globalAddDeviceModal.activeTabIndex,
      (val) => {
        console.log('current Tab', val);
        // if (val === 0) {
        //   globalAddDeviceModal.btnCancel = btnBorderMainStyleFull('Download Sample');
        //   globalAddDeviceModal.btnConfirm = btnMainStyleFull('Upload CSV');
        // }
        if (val === 1) {
          // generate code tab
          // check code vailidate
          _checkCodeInValid();
        } //end: if
        console.log('globalAddDeviceModal', globalAddDeviceModal);
      }
    );

    // check 是否需要顯示邀請碼

    const _checkCodeInValid = async () => {
      try {
        const config = {
          refresh: false, //是否要強制更新
        };
        const datas = await apiInvitations(config);
        globalAddDeviceModal.time = datas.expires_at;
        const isCodeExpire = globalAddDeviceModal.time <= Date.now();
        console.log('isCodeExpire', isCodeExpire);

        if (isCodeExpire) {
          //強制更新
          globalAddDeviceModal.isStart = false;
          globalAddDeviceModal.isShowCode = false;
          globalAddDeviceModal.btnCodeDisable = false;
        } //end: if
        else {
          _handleInvitationCodeDisplay(datas);
        } //end: esle
      } catch (err) {
        console.warn('err', err.reponse);
      }
    }; //end: _checkCodeInValid

    // 顯示邀請碼
    const generateCode = async () => {
      globalAddDeviceModal.btnGenerateDisable = true;
      try {
        const data = {
          refresh: true, //是否要強制更新
        };
        const datas = await apiInvitations(data);
        _handleInvitationCodeDisplay(datas);
      } catch (err) {
        console.warn('err', err.reponse);
      }
      globalAddDeviceModal.btnGenerateDisable = false;
    }; //end: generateCode

    //處理邀請碼的顯示
    const _handleInvitationCodeDisplay = (datas) => {
      const _datas = datas;
      globalAddDeviceModal.code = _datas.data;
      globalAddDeviceModal.time = _datas.expires_at; //temp for this verion
      // globalAddDeviceModal.time = 1645862452000;
      globalAddDeviceModal.expireTime = _datas.expires_at; //過期時間

      //開始倒數
      globalAddDeviceModal.isStart = true;
      globalAddDeviceModal.isShowCode = true;
      globalAddDeviceModal.btnCodeDisable = false;
    }; //end: _handleInvitationCodeDisplay

    const finshTimer = () => {
      console.log('finshTimer');
      globalAddDeviceModal.isShowCode = false;
      globalAddDeviceModal.isStart = false;
      globalAddDeviceModal.btnCodeDisable = false;
      proxy.$forceUpdate();
    };

    const closeGlobalAddDevice = () => {
      globalAddDeviceModal.code = '';
      globalAddDeviceModal.isStart = false;
      globalAddDeviceModal.isShowCode = false;
      globalAddDeviceModal.btnCodeDisable = false;
      globalAddDeviceModal.activeTabIndex = 0;
    };

    const importCVSModal = reactive({
      optionsFilter: [
        {
          //filter select
          text: 'Checking status',
          val: CHECKING_STATUS.ALL,
          isI18n: '__main.__checkingStatus',
        },
        {
          text: 'Bindable',
          val: CHECKING_STATUS.BINDABLE, //
          isI18n: '__main.__bindable',
        },
        {
          text: 'Error',
          val: CHECKING_STATUS.ERROR,
          isI18n: '__main.__error',
        },
        {
          text: 'Bound by...',
          val: CHECKING_STATUS.BOUNDBY,
          isI18n: '__main.__boundBy',
        },
        {
          text: 'Bound',
          val: CHECKING_STATUS.BOUND,
          isI18n: '__main.__bound',
        },
        {
          text: 'Invitated by...',
          val: CHECKING_STATUS.INVITATEBY,
          isI18n: '__main.__invitedBy',
        },
      ],
      selectedFilter: {
        text: 'Checking status',
        val: CHECKING_STATUS.ALL,
        isI18n: '__main.__checkingStatus',
      },
      rawDatas: [], // api raw data
      columns: [
        // i18n 廢棄
        {
          title: 'Order',
          key: 'order',
          width: '15%',
          sort: true,
        },
        {
          title: 'Serial Number',
          key: 'sn',
          width: '50%',
          sort: true,
        },
        {
          title: 'Checking Status',
          key: 'status',
          width: '35%',
          sort: true,
        },
      ],

      /** data
        {
            id: 'xxx'
            order: "1",
            sn: "SN-AA-DDD-DDDD-DDDD",
            status: "Bound",
          },
         */
      data: [], //end: data
      initData: [], // end: initData : 存沒有被filter的data
      checkTotal: 0,
      deviceAddListSSN: [], //要被加入的ssn
      defaultCheckIndexList: [], //要被勾起的indx
      disableCheckList: [], //disable or able checkbox
      isFirstCheckbox: true, //是否第一次進到checkbox all
      isErrorLength: false, //是否超過20個錯誤
    });

    const importCVSModal_columns = computed(() => {
      return [
        {
          title: t('__main.__order'),
          key: 'order',
          width: '15%',
          sort: true,
        },
        {
          title: t('__g3p_m8t.__serialNumber'),
          key: 'sn',
          width: '50%',
          sort: true,
        },
        {
          title: t('__main.__checkingStatus'),
          key: 'status',
          width: '35%',
          sort: true,
        },
      ];
    });

    const modalTableScrollHeight = computed(() => {
      return storeState.mobileDevice ? '40vh' : '340px';
    });

    const csvCheckTotal = ref(0);

    const isCSVBtnCancel = () => {
      return importCVSModal.isErrorLength
        ? t('__common.__confirm')
        : t('__common.__cancel');
    };

    let btnCsvUpload = null; // choose file btn
    const csvUploadBtn = ref();
    // click tigger open file manager
    const uploadCSV = () => {
      btnCsvUpload.click();
    }; //end: uploadCSV

    // uploading csv file
    const uploadCSVFile = async (event) => {
      console.log('event', event);
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        try {
          const _temp = await apiCSVUpload(formData);
          const data = _temp.data;
          console.log('data', data);

          importCVSModal.isErrorLength =
            data
              .map((e) => {
                return e.state == 0;
              })
              .filter((e) => e).length > 20
              ? true
              : false;
          // console.log('errorLength', importCVSModal.isErrorLength)

          importCVSModal.rawDatas = [...data];
          handleCSVModalData(importCVSModal.rawDatas);
          console.log('imporCSVMODAL DATA', importCVSModal.rawDatas);
          showImportCSVModalGlobal(data);
        } catch (err) {
          console.log('message', err.response.data.message);

          console.warn('error in apiCSVUpload', err.status);
        } //end: catch
      } //end: if
    }; //end: uploadCSVFile

    const copyInviteCode = () => {
      navigator.clipboard.writeText(globalAddDeviceModal.code);
    }; // end onClickDownloadCSV

    const onClickDownloadCSV = () => {
      window.location.href = 'download/sampleCSV.csv';
    }; // end onClickDownloadCSV

    const showImportCSVModalGlobal = (data) => {
      const modalConfig = {
        type: POPUP.IMPORTCSV,
        data: data,
        isShow: true,
      };
      store.commit('setIsShowModal', modalConfig);
    };

    const callBackAddDevice = (data = '') => {
      closeModal();
      setTimeout(() => {
        const modalConfig = {
          type: POPUP.GLOBALADDDEVICE,
          data: data,
          isShow: true,
        };
        store.commit('setIsShowModal', modalConfig);
      }, 600);
    }; //end: call back  side add device

    // //判斷是哪一種check status
    // const _handleCheckStatue = (type) => {
    //   if (type.indexOf('Bound by') != -1) {
    //     return CHECKING_STATUS.BOUNDBY;

    //   } else if (type.indexOf('Bound') != -1) {
    //     return CHECKING_STATUS.BOUND;

    //   } else if (type.indexOf('Wrong Serial Number') != -1) {
    //     return CHECKING_STATUS.ERROR;

    //   } else if (type.indexOf('Invitated') != -1) {
    //     return CHECKING_STATUS.INVITATEBY;
    //   } else {
    //     // Boundable
    //     return CHECKING_STATUS.BINDABLE;
    //   }
    // }; //end: handleCheckStatue

    // handle import csv modal table content
    const handleCSVModalData = (data) => {
      const _data = data;
      const _filterOptions = []; //for filter checking status
      const _checkingStatusList = [];
      let _boundedTotal = 0; //已被綁定的數量
      console.log('handleCSVModalData _data', data);
      importCVSModal.data = [];
      importCVSModal.disableCheckList = [];
      importCVSModal.deviceAddListSSN = []; // 需被加入的ssn list
      importCVSModal.defaultCheckIndexList = [];

      _filterOptions.push({
        text: 'Checking status',
        value: 'all',
      });

      // console.log('importCVSModal', importCVSModal.data);
      _data.forEach((item, index) => {
        // console.log('foreach', item)
        // handle table data
        importCVSModal.data.push({
          id: item.id,
          order: index + 1,
          sn: item.ssn,
          status: item.reason,
          state: item.state, // 0 fail, 1 can bind, 2 relate to user device
          checkType: item.case, // 0: format error, 1: Bound by, 2: invited by, 3 Bindable, 4. bound (自己綁定)
        }); //end: push

        if (item.state === 2) {
          _boundedTotal = _boundedTotal + 1;
        }

        // console.log('_boundedTotal', _boundedTotal);
        // console.log('importCVSModal.defaultCheckIndexList', importCVSModal.defaultCheckIndexList);

        importCVSModal.disableCheckList.push(item.state != 1); // 0, 2 disable , 1 enable
        // console.log('item', item)
        if (item.case === 4 || item.case === 3) {
          //Bound by XXX或是 Invitated by XXX或是 wrong format的機台不能有預設勾勾
          importCVSModal.defaultCheckIndexList.push(index);
        }

        // handle checking status select
        _checkingStatusList.push(item.reason);
        //預設勾起來 case 3 的ssn加入arr (case 4 已加入 不需要再加入)
        if (item.case === 3) {
          importCVSModal.deviceAddListSSN.push(item.ssn);
        }
        // console.log('_checkingstat', _checkingStatusList);
      }); //end : foreach
      console.log(
        'disable:',
        importCVSModal.disableCheckList.filter((item) => item)
      );
      importCVSModal.initData = [...importCVSModal.data];
      console.log('importCVSMODAL data', importCVSModal.data);
      console.log('importCVSMODAL initData', importCVSModal.initData);
      console.log(
        '???????',
        importCVSModal.defaultCheckIndexList.length,
        _boundedTotal
      );
      csvCheckTotal.value = importCVSModal.deviceAddListSSN.length;
      // console.log('importCVSModal.defaultCheckIndexList.length', csvCheckTotal.value, importCVSModal.checkTotal, importCVSModal.defaultCheckIndexList.length);
    }; //end: handleCSVModalData

    // sort csv data
    const sortCSVData = (v) => {
      const _data = v;
      const {key, val} = _data;
      sortByKey(importCVSModal.data, key, val);
      importCVSModal.initData = [...importCVSModal.data];
    }; //end: sortCSVData;

    // filter csv data
    const onChangeFilter = (v) => {
      console.log('onChnageFilter', v);

      const {val} = v;
      if (val === CHECKING_STATUS.ALL) {
        importCVSModal.data = [...importCVSModal.initData];
      } else {
        const _data = importCVSModal.initData.filter(
          (item) => item.checkType === val
        );
        importCVSModal.data = [..._data];
      }
      // state == 2 invited device need checked default
      // console.log('importCVSModal.data', importCVSModal.data);
      const bindableIndexList = importCVSModal.data
        .map((item, index) =>
          item.checkType === 3 || item.checkType === 4 ? index : undefined
        )
        .filter((x) => typeof x !== 'undefined');
      // console.log('bindableIndexList', importCVSModal.data.map((item, index) => item.checkType === 3 || item.checkType === 4 ? index : undefined), bindableIndexList);
      importCVSModal.defaultCheckIndexList = bindableIndexList;
      // importCVSModal.defaultCheckIndexList = bindableIndexList.filter(item => !importCVSModal.defaultCheckIndexList.includes(item));
      // keep disable
      importCVSModal.disableCheckList = [];
      importCVSModal.data.forEach((item) => {
        importCVSModal.disableCheckList.push(item.state != 1);
      });
      proxy.$forceUpdate();
      // console.log('data', importCVSModal.data);
      // console.log('initData', importCVSModal.initData);

      importCVSModal.deviceAddListSSN = [];
      const addListSSN = importCVSModal.data
        .filter((item) => item.checkType === 3)
        .map((ele) => ele.sn);
      importCVSModal.deviceAddListSSN = [...addListSSN];
      csvCheckTotal.value = importCVSModal.deviceAddListSSN.length;
    }; //end: onChangeFilter

    // handle checkbox
    // todo onCheckAllCSV
    const onCheckAllCSV = (v) => {
      const _data = v;

      console.log('onCheckAllCSV', _data);
      _onCheckCSV(_data);
    };

    const onCheckEachCSVData = (v) => {
      const _data = v;
      if (importCVSModal.isFirstCheckbox) {
        importCVSModal.isFirstCheckbox = false;
        return;
      }
      console.log('onCheckEachCSVData', _data);
      _onCheckCSV(_data);
    };

    const _onCheckCSV = (data) => {
      const _data = data;
      console.log('_onCheckCSV data', data);
      importCVSModal.deviceAddListSSN = [];
      importCVSModal.deviceAddListSSN = _data
        .filter((item) => item.checkType === 3)
        .map((item) => item.sn);
      csvCheckTotal.value = importCVSModal.deviceAddListSSN.length;
      console.log(
        'importCVSModal.deviceAddListSSN ',
        importCVSModal.deviceAddListSSN
      );
    };

    //新增csv device
    const onSubmitCSVDeviceAdd = async () => {
      const _data = [...importCVSModal.deviceAddListSSN];
      console.log('onSubmitCSVDeviceAdd', _data);
      const config = {
        ssn: _data,
      };
      try {
        await apiDeviceAdd(config);
        const flashMsg = {
          data: `${t('__flash.__uploadSuccessfully')}`,
          isShow: true,
        };
        store.commit('setFlashMsg', flashMsg);
        console.log('add device success');
      } catch (err) {
        console.log('in error upload');
        store.commit('setCloseModal');
        const flashMsg = {
          data: `${t('__flash.__uploadFailed')}`,
          isShow: true,
        };
        store.commit('setFlashMsg', flashMsg);

        console.warn('error apiDeviceAdd', err.response);
      }
    }; // end: onSubmit

    //watch modal open
    watchEffect(() => {
      // console.log('watchEffect:  modal Type:', state.type, 'isOpen:', state.isOpenModal)
      if (state.isOpenModal && state.type == POPUP.GLOBALADDDEVICE) {
        // console.log('csvUploadBtnBtn', csvUploadBtn.value);
        btnCsvUpload = csvUploadBtn.value;
      } //end: if
      else if (state.isOpenModal && state.type == POPUP.IMPORTCSV) {
        // console.log('IMPORTCSV');
      } else if (!state.isOpenModal && state.type == POPUP.IMPORTCSV) {
        // reset
        // console.log('reset import CSV Data')
        importCVSModal.checkTotal = 0;
        importCVSModal.deviceAddListSSN = []; //要被加入的ssn
        importCVSModal.defaultCheckIndexList = []; //要被勾起的indx
        importCVSModal.disableCheckList = []; //disable or able checkbox
        importCVSModal.isFirstCheckbox = true; //是否第一次進到checkbox all
        importCVSModal.isErrorLength = false; //是否超過20個錯誤
        importCVSModal.selectedFilter = {
          text: 'Checking status',
          val: CHECKING_STATUS.ALL,
          isI18n: '__main.__checkingStatus',
        };
      } //end: else
      else if (!state.isOpenModal && state.type === POPUP.DEVICEDETAIL) {
        groupVal.selectVal2 = {
          text: t('__d7d_n17r.__allDevices'),
          val: '',
          isI18n: '__d7d_n17r.__allDevices',
        };
      } //end: else
    });

    //delete now
    const licenseModal_columns = computed(() => {
      return [
        {
          title: t('__main.__packageName'),
          key: 'name',
          width: '24%',
          isI18n: '__main.__packageName',
        },
        {
          title: t('__main.__licenseCol'),
          key: 'type',
          width: '20%',
          isI18n: '__main.__licenseCol',
        },
        {
          title: t('__popup.__url'),
          key: 'url',
          width: '41%',
          isLink: true,
          isI18n: '__popup.__url',
          align: 'alignLeft',
        },
      ];
    });

    // license
    const licenseModal = reactive({
      tabText: [
        {
          name: 'Web',
          val: 'l-tab1',
          disabled: false,
          alertText: '',
          isI18n: '__main.__web',
        },
        {
          name: 'Client Agent',
          val: 'l-tab2',
          disabled: false,
          alertText: '',
          isI18n: '__popup.__clientAgent',
        },
      ],
      activeTabIndex: 0,
      columns: [
        //i18n 廢棄
        {
          title: 'Package Name',
          key: 'name',
          width: '24%',
        },
        {
          title: 'Type',
          key: 'type',
          width: '15%',
        },
        {
          title: 'URL',
          key: 'url',
          width: '41%',
          isLink: true,
          align: 'alignLeft',
        },
      ],
      //delete now
      agentData: [
        {
          name: 'CommandLineParser',
          type: 'MIT License',
          url: 'https://github.com/commandlineparser/command/ddd',
        },
        {
          name: 'CommandLineParser',
          type: 'MIT License',
          url: 'https://github.com/commandlineparser/command/aaaaaaaaa',
        },
      ],
      providerData: [
        {
          name: 'CommandLineParser',
          type: 'MIT License',
          url: 'https://github.com/commandlineparser/command/ddd',
        },
        {
          name: 'CommandLineParser',
          type: 'MIT License',
          url: 'https://github.com/commandlineparser/command/aaaaaaaaa',
        },
        {
          name: 'CommandLineParser',
          type: 'MIT License',
          url: 'https://github.com/commandlineparser/command/ddd',
        },
        {
          name: 'CommandLineParser',
          type: 'MIT License',
          url: 'https://github.com/commandlineparser/command/aaaaaaaaa',
        },
      ],
    });
    const onClickLicenseTab = (val) => {
      const _activeTab = val.index;
      licenseModal.activeTabIndex = _activeTab;
    };
    const golicenseLink = (v) => {
      window.open(v.val.url, '_blank');
    };

    const onCloseLicense = () => {
      licenseModal.activeTabIndex = 0;
    };

    // Detials_popup
    const Detial_icon = (i) => {
      // console.log(i, 'Detial_icon App')
      if (i.report != null) {
        window.open(i.report);
      }
    };

    //#region Dashboard getTasks
    // state.data.list = datas.tasks
    const tableSortDashboard = (v) => {
      console.log(v, 'sort table');
      getDashboardDetail(v);
    };
    const getDashboardDetail = async (v) => {
      console.log(v, 'ooo');
      const id = state.data.id;
      const sendData = {
        sort: v.key,
        order: v.val === 'up' ? 'asc' : 'desc',
      };
      try {
        const data = await apiGetTasks(id, sendData);
        console.log('apiGetTasks', data);

        state.data.deviceListData = data.tasks;
        for (let i = 0; i < state.data.deviceListData.length; i++) {
          state.data.deviceListData[i].newStatus = null;
          if (state.data.deviceListData[i].deleted) {
            state.data.deviceListData[i].newStatus = 4;
          } else if (state.data.deviceListData[i].status == 0) {
            state.data.deviceListData[i].newStatus = 999;
          } else {
            state.data.deviceListData[i].newStatus =
              state.data.deviceListData[i].status;
          }
        }
        // console.log( state.data.deviceListData)
      } catch (err) {
        console.log('apiGetTasks', 'err');
      }
    };

    const goDashboardTaskLink = (v) => {
      console.log(v, 'table link');
      const ssn = v.val.ssn;
      router.push({
        name: FEATURENAME.DEVICEDETAIL,
        params: {name: ssn, tabId: ACTIONBAR.VIEWHIS},
      });
      closeModal();
    };

    //#endregion

    const showCTAndRow = (v) => {
      console.log(v, 'showContextMenu and row');
    };
    const goTableLink = (v) => {
      console.log(v, 'table link');
    };
    const onCheckEach = (v) => {
      console.log(v, 'table onCheckEach');
    };
    const onCheckAll = (v) => {
      console.log(v, 'table onCheckAll');
    };
    const tableSort = (v) => {
      console.log(v, 'sort table');
    };

    //#region calibration

    const gamutOnChange = () => {
      // console.log('1324354',state.data.target['val'])
      if (state.data.target['val'] == '5') {
        //5 == DICOM，預防state.data.gamut一進入網站時會被render
        state.data.gamut = state.data.dicomGamut['text'];
        state.data.target = {
          //APP 端是一切換選單就Customized，不會再變回來
          text: 'Customized',
          val: state.data.target.val,
          isI18n: '__c3r_c9n.__customized',
        };
      }
      console.log('8', state.data.target);
    };

    //calibration group choose start

    const chose_group = (v) => {
      console.log('click', v);
      state.customized = v;
    };

    const chose_groups_all = (v) => {
      state.customized = [];
      state.customized = v;
    };

    const tableSortGroup = (v) => {
      // getTasks(v)
    };

    const close_customized_group = (btnType = BTN.CANCEL) => {
      const _btnType = btnType + uuid.v1();
      // console.log('btnType', _btnType);
      store.commit('setModalBtnType', _btnType);
      store.commit('setCloseModal');
      // state.customized = [];
    };

    const send_customized_group = () => {
      submitModal({title: 'group', data: state.customized});
      state.customized = [];
    };

    //calibration device choose start

    const chose_devices = (v) => {
      // console.log("click",v)
      // console.log(state.customized,"customized")
      for (let a = 0; a < state.data.list.length; a++) {
        const n = v
          .map((x) => x.serialNumber)
          .indexOf(state.data.list[a].serialNumber);
        // console.log(n)
        if (n == -1) {
          var d = state.customized
            .map((x) => x.serialNumber)
            .indexOf(state.data.list[a].serialNumber);
          if (d != -1) {
            state.customized.splice(d, 1);
          }
        } else {
          d = state.customized
            .map((x) => x.serialNumber)
            .indexOf(state.data.list[a].serialNumber);
          if (d == -1) {
            state.customized.push(v[n]);
          }
        }
      }
      calibration_data.isGroup = state.data.group_op[0];
      state.data.isgroup == '';
    };
    const chose_devices_all = (v) => {
      console.log('click_all', v);
      state.customized = [];
      v.forEach((element) => {
        state.customized.push(element);
      });
      calibration_data.isGroup = calibration_data.group;
      state.data.isgroup == '';
    };
    const send_customized = () => {
      submitModal({title: 'device', data: state.customized});
      state.customized = [];
      calibration_data.group = state.data.group_op[0];
      calibration_data.device = state.data.device_op[0];
    };
    const close_customized = (btnType = BTN.CANCEL) => {
      const _btnType = btnType + uuid.v1();
      console.log('btnType', _btnType);
      store.commit('setModalBtnType', _btnType);
      store.commit('setCloseModal');
      state.customized = [];
      calibration_data.group = state.data.group_op[0];
      calibration_data.device = state.data.device_op[0];
    };
    const getAPITablesData = async () => {
      try {
        const _send = {
          page: 1,
          per_page: 99999999,
        };
        state.data.defaultCheck = [];
        if (calibration_data.device.val != 'All') {
          if (calibration_data.device.val == '0') {
            _send['status'] = '0';
          } else if (calibration_data.device.val == '1') {
            _send['status'] = 1;
          } else if (calibration_data.device.val == '2') {
            _send['status'] = 2;
          } else {
            _send['model'] = calibration_data.device.val;
          }
        }
        const data = await apiGetDevice(_send);
        // console.log('table data', data);
        state.data.list = [];
        const _data = data.data;
        for (var a = 0; a < _data.length; a++) {
          let group = '';
          let _add_group = false;
          if (calibration_data.group.val == 'All') {
            _add_group = true;
          }
          for (let b = 0; b < _data[a].group.length; b++) {
            if (calibration_data.group.text == _data[a].group[b]) {
              _add_group = true;
            }
            if (b == _data[a].group.length - 1) {
              group += _data[a].group[b];
            } else {
              group += _data[a].group[b] + ',';
            }
          }
          const _table = {
            serialNumber: _data[a].ssn,
            model: _data[a].model,
            pcName: _data[a].host,
            group: group,
            connectionStatus: _data[a].status,
            ip: _data[a].ip,
          };
          if (_add_group && _data[a].status != 2) {
            state.data.list.push(_table);
            if (calibration_data.group.text == state.data.isgroup) {
              state.data.defaultCheck.push(state.data.list.length - 1);
            }
          }
        }
        // console.log("state.customized",state.customized)
        for (a = 0; a < state.data.list.length; a++) {
          const _c = state.customized
            .map((x) => x.serialNumber)
            .indexOf(state.data.list[a].serialNumber);
          if (_c != -1) {
            state.data.defaultCheck.push(a);
          }
        }
      } catch (err) {
        console.log('err');
      }
    };
    //calibration device choose end
    const saveCustomized = async () => {
      // submitModal(state.save_customized_name);
      // store.commit('setCloseModal');
      state.data['name'] = state.save_customized_name;
      const send = Object.fromEntries(
        Object.entries(state.data).filter(([_, v]) => {
          return _ != 'gamut_text' && v != null;
        })
      );
      send.color_temperature = Number(send.color_temperature);
      // console.log('send',send.color_temperature, send)
      try {
        await apiSetTargetList(send);
        submitModal(state.save_customized_name);
        store.commit('setCloseModal');
        state.save_customized_name = '';
      } catch (err) {
        if (err.response.data.status_code == 13) {
          state.data.nameError = true;
        }
      }
    };
    const skipCustomized = () => {
      submitModal('Customized');
      state.save_customized_name = '';
    };

    const CheckAllSlide = () => {
      let _return = true;
      if (
        state.data.brightness_max_data.length > 0 &&
        state.data.brightness_max_start != state.data.brightness_max
      ) {
        _return = false;
      }
      if (
        state.data.brightness_min_data.length > 0 &&
        state.data.brightness_min_start != state.data.brightness_min
      ) {
        _return = false;
      }
      if (
        state.data.temperature_data.length > 0 &&
        state.data.temperature_start * 100 != state.data.temperature
      ) {
        _return = false;
      }
      if (
        state.data.gamma_data.length > 0 &&
        state.data.gamma_start != state.data.gamma
      ) {
        _return = false;
      }
      if (state.data.target_op.length > 0 && _return) {
        const _d = state.data.target_op
          .map((x) => x.val)
          .indexOf(state.data.target.val);
        if (_d == -1) return;
        const _target = state.data.target_op[_d];
        state.data.target.isI18n = _target.isI18n;
        state.data.target.text = _target.text;
      }
    };
    const brightness_max_change = (e) => {
      state.data.brightness_max = e;
      if (e != state.data.brightness_max_start && e != 1000000) {
        // state.data.target.text = "Customized"
        state.data.target = {
          text: 'Customized',
          val: state.data.target.val,
          isI18n: '__c3r_c9n.__customized',
        };
      } else {
        CheckAllSlide();
      }
    };
    const brightness_min_change = (e) => {
      state.data.brightness_min = e;
      console.log('brightness_min_change', e);
      if (e != state.data.brightness_min_start) {
        state.data.target = {
          text: 'Customized',
          val: state.data.target.val,
          isI18n: '__c3r_c9n.__customized',
        };
      } else {
        CheckAllSlide();
      }
    };
    const temperature_change = (e) => {
      // console.log("data", state.data)
      state.data.temperature = e;
      if (e != state.data.temperature_start * 100) {
        state.data.target = {
          text: 'Customized',
          val: state.data.target.val,
          isI18n: '__c3r_c9n.__customized',
        };
      } else {
        CheckAllSlide();
      }
    };
    const gamma_change = (e) => {
      state.data.gamma = e;
      if (e != state.data.gamma_start) {
        state.data.target = {
          text: 'Customized',
          val: state.data.target.val,
          isI18n: '__c3r_c9n.__customized',
        };
      } else {
        CheckAllSlide();
      }
    };
    const coordinate_change = (e) => {
      // console.log('?')
      if (
        e['x'] != state.data.coordinateEnum['x']['default'] ||
        e['y'] != state.data.coordinateEnum['y']['default']
      ) {
        state.data.target = {
          text: 'Customized',
          val: state.data.target.val,
          isI18n: '__c3r_c9n.__customized',
        };
      } else {
        CheckAllSlide();
      }
    };
    const setLineBar = () => {
      let _mode = ''; //DICOM,HDR,SDR
      //#region 判斷_mode
      let _key;
      if (_mode == '' && state.data.EOTF.text == 'DICOM') {
        _mode = 'DICOM';
      }
      if (_mode == '' && state.data.APICalibrationData['eotf']['HDR']) {
        _key = Object.keys(state.data.APICalibrationData['eotf']['HDR']);
        for (let hdr = 0; hdr < _key.length; hdr++) {
          if (state.data.EOTF.text == _key[hdr]) {
            _mode = 'HDR';
          }
        }
      }
      if (_mode == '' && state.data.APICalibrationData['eotf']['SDR']) {
        _key = Object.keys(state.data.APICalibrationData['eotf']['SDR']);
        for (let sdr = 0; sdr < _key.length; sdr++) {
          if (state.data.EOTF.text == _key[sdr]) {
            _mode = 'SDR';
          }
        }
      }
      //#endregion

      if (_mode == 'DICOM') {
        state.data.brightness_max_data = [];
        state.data.brightness_min_data = [];
        state.data.temperature_data = [];
        state.data.gamma_data = [];
        var _difference_max =
          (state.data.APICalibrationData['brightness']['DICOM']['brightness'][
            'range_max'
          ] -
            state.data.APICalibrationData['brightness']['DICOM']['brightness'][
              'range_min'
            ]) /
          6;
        for (var a = 0; a <= 6; a++) {
          var _math = 100;
          if (
            state.data.APICalibrationData['brightness']['DICOM']['brightness'][
              'range_min'
            ] /
              100 <
              1 ||
            state.data.APICalibrationData['brightness']['DICOM']['brightness'][
              'range_max'
            ] -
              state.data.APICalibrationData['brightness']['DICOM'][
                'brightness'
              ]['range_min'] <
              100
          ) {
            _math = 10;
          }
          var _max =
            Math.round(
              (state.data.APICalibrationData['brightness']['DICOM'][
                'brightness'
              ]['range_min'] +
                _difference_max * a) /
                _math
            ) * _math;
          state.data.brightness_max_data.push(_max);
        }
        state.data.brightness_min_data =
          state.data.APICalibrationData['brightness']['DICOM'][
            'brightness_min'
          ]['range_values'];
        state.data.brightness_max_data = state.data.brightness_max_data.filter(
          function (ele, pos) {
            return state.data.brightness_max_data.indexOf(ele) == pos;
          }
        );
        state.data.brightness_max_max =
          state.data.APICalibrationData['brightness']['DICOM']['brightness'][
            'max'
          ];
        state.data.brightness_max_min =
          state.data.APICalibrationData['brightness']['DICOM']['brightness'][
            'min'
          ];
        state.data.brightness_min_max =
          state.data.APICalibrationData['brightness']['DICOM'][
            'brightness_min'
          ]['max'];
        state.data.brightness_min_min =
          state.data.APICalibrationData['brightness']['DICOM'][
            'brightness_min'
          ]['min'];
        state.data.brightness_max_step =
          state.data.APICalibrationData['brightness']['DICOM']['brightness'][
            'step'
          ];
        state.data.bright_max = state.data.APICalibrationData['brightness_max'];
        state.data.bright_min = state.data.APICalibrationData['brightness_min'];
        if (state.data.brightness_max_start == 0) {
          state.data.brightness_max_start = state.data.brightness_max_data[0];
        } else if (
          state.data.brightness_max_start >
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ] &&
          !state.data.brightness_max_max
        ) {
          state.data.brightness_max_start =
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ];
        } else if (
          state.data.brightness_max_start >
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ] &&
          state.data.brightness_max_max &&
          state.data.brightness_max_start != state.data.bright_max
        ) {
          state.data.brightness_max_start =
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ];
        }
        if (state.data.brightness_min_start == -1) {
          state.data.brightness_min_start = state.data.brightness_min_data[0];
        } else if (
          state.data.brightness_min_start != state.data.bright_min &&
          state.data.brightness_min_min &&
          state.data.brightness_min_start < state.data.brightness_min_data[0]
        ) {
          state.data.brightness_min_start = state.data.brightness_min_data[0];
        } else if (
          !state.data.brightness_min_min &&
          state.data.brightness_min_start < state.data.brightness_min_data[0]
        ) {
          state.data.brightness_min_start = state.data.brightness_min_data[0];
        }
        // if (state.data.APICalibrationData['color_temperature']['SDR']['fix']) {
        //   state.data.temperature_lock = true;
        //   state.data.temperature_start =
        //     state.data.APICalibrationData['color_temperature']['SDR']['fix'] /
        //     100;
        //   _difference_max = (10000 - 4000) / 6;
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.data.temperature_data.push(_max / 100);
        //   }
        //   state.data.temperature_data = state.data.temperature_data.filter(
        //     function (ele, pos) {
        //       return state.data.temperature_data.indexOf(ele) == pos;
        //     }
        //   );
        // } else 
        if (
          state.data.APICalibrationData['color_temperature']['step']
        ) {
          state.data.temperature_lock = false;
          _difference_max =
            (state.data.APICalibrationData['color_temperature'][
              'range_max'
            ] -
              state.data.APICalibrationData['color_temperature'][
                'range_min'
              ]) /
            6;
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (
              state.data.APICalibrationData['color_temperature'][
                'range_min'
              ] /
                100 <
              1
            ) {
              _math = 10;
            }
            _max =
              Math.round(
                (state.data.APICalibrationData['color_temperature'][
                  'range_min'
                ] +
                  _difference_max * a) /
                  _math
              ) * _math;
            state.data.temperature_data.push(_max / 100);
          }
          state.data.temperature_data = state.data.temperature_data.filter(
            function (ele, pos) {
              return state.data.temperature_data.indexOf(ele) == pos;
            }
          );
          if (state.data.temperature_start == 0) {
            state.data.temperature_start = state.data.temperature_data[0];
          } else if (
            state.data.temperature_start >
            state.data.temperature_data[state.data.temperature_data.length - 1]
          ) {
            state.data.temperature_start =
              state.data.temperature_data[
                state.data.temperature_data.length - 1
              ];
          } else if (
            state.data.temperature_start < state.data.temperature_data[0]
          ) {
            state.data.temperature_start = state.data.temperature_data[0];
          }
        }
      }
      if (_mode == 'HDR') {
        state.data.brightness_max_data = [];
        state.data.brightness_min_data = [];
        state.data.temperature_data = [];
        state.data.gamma_data = [];
        _difference_max =
          (state.data.APICalibrationData['brightness']['HDR']['range_max'] -
            state.data.APICalibrationData['brightness']['HDR']['range_min']) /
          6;
        for (a = 0; a <= 6; a++) {
          _math = 100;
          if (
            state.data.APICalibrationData['brightness']['HDR']['range_min'] /
              100 <
            1
          ) {
            _math = 10;
          }
          _max =
            Math.round(
              (state.data.APICalibrationData['brightness']['HDR']['range_min'] +
                _difference_max * a) /
                _math
            ) * _math;
          state.data.brightness_max_data.push(_max);
        }
        state.data.brightness_max_data = state.data.brightness_max_data.filter(
          function (ele, pos) {
            return state.data.brightness_max_data.indexOf(ele) == pos;
          }
        );
        state.data.bright_max = state.data.APICalibrationData['brightness_max'];
        state.data.bright_min = state.data.APICalibrationData['brightness_min'];
        if (state.data.brightness_max_start == 0) {
          state.data.brightness_max_start = state.data.brightness_max_data[0];
        } else if (
          state.data.brightness_max_start >
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ] &&
          !state.data.brightness_max_max
        ) {
          state.data.brightness_max_start =
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ];
        } else if (
          state.data.brightness_max_start >
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ] &&
          state.data.brightness_max_max &&
          state.data.brightness_max_start != state.data.bright_max
        ) {
          state.data.brightness_max_start =
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ];
        }
        state.data.brightness_max_max =
          state.data.APICalibrationData['brightness']['HDR']['max'];
        state.data.brightness_max_min =
          state.data.APICalibrationData['brightness']['HDR']['min'];
        state.data.brightness_max_step =
          state.data.APICalibrationData['brightness']['HDR']['step'];
        // if (state.data.APICalibrationData['color_temperature']['HDR']['fix']) {
        //   state.data.temperature_lock = true;
        //   state.data.temperature_start =
        //     state.data.APICalibrationData['color_temperature']['HDR']['fix'] /
        //     100;
        //   _difference_max = (10000 - 4000) / 6;
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.data.temperature_data.push(_max / 100);
        //   }
        //   state.data.temperature_data = state.data.temperature_data.filter(
        //     function (ele, pos) {
        //       return state.data.temperature_data.indexOf(ele) == pos;
        //     }
        //   );
        // } else 
        if (
          state.data.APICalibrationData['color_temperature']['step']
        ) {
          state.data.temperature_lock = false;
          _difference_max =
            (state.data.APICalibrationData['color_temperature'][
              'range_max'
            ] -
              state.data.APICalibrationData['color_temperature'][
                'range_min'
              ]) /
            6;
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (
              state.data.APICalibrationData['color_temperature'][
                'range_min'
              ] /
                100 <
              1
            ) {
              _math = 10;
            }
            _max =
              Math.round(
                (state.data.APICalibrationData['color_temperature'][
                  'range_min'
                ] +
                  _difference_max * a) /
                  _math
              ) * _math;
            state.data.temperature_data.push(_max / 100);
          }
          state.data.temperature_data = state.data.temperature_data.filter(
            function (ele, pos) {
              return state.data.temperature_data.indexOf(ele) == pos;
            }
          );
          if (state.data.temperature_start == 0) {
            state.data.temperature_start = state.data.temperature_data[0];
          } else if (
            state.data.temperature_start >
            state.data.temperature_data[state.data.temperature_data.length - 1]
          ) {
            state.data.temperature_start =
              state.data.temperature_data[
                state.data.temperature_data.length - 1
              ];
          } else if (
            state.data.temperature_start < state.data.temperature_data[0]
          ) {
            state.data.temperature_start = state.data.temperature_data[0];
          }
        }
      }
      if (_mode == 'SDR') {
        state.data.brightness_max_data = [];
        state.data.brightness_min_data = [];
        state.data.temperature_data = [];
        state.data.gamma_data = [];
        if (state.data.EOTF.text == 'Gamma') {
          state.data.gamma_data = state.data.gamma_data_default;
          if (state.data.gamma_start == 0) {
            state.data.gamma = state.data.gamma_data[0];
          } else if (state.data.gamma_start < state.data.gamma_data[0]) {
            state.data.gamma_start = state.data.gamma_data[0];
          } else if (
            state.data.gamma_start >
            state.data.gamma_data[state.data.gamma_data.length - 1]
          ) {
            state.data.gamma_start =
              state.data.gamma_data[state.data.gamma_data.length - 1];
          }
        }
        _difference_max =
          (state.data.APICalibrationData['brightness']['SDR']['range_max'] -
            state.data.APICalibrationData['brightness']['SDR']['range_min']) /
          6;
        for (a = 0; a <= 6; a++) {
          _math = 100;
          if (
            state.data.APICalibrationData['brightness']['SDR']['range_min'] /
              100 <
            1
          ) {
            _math = 10;
          }
          _max =
            Math.round(
              (state.data.APICalibrationData['brightness']['SDR']['range_min'] +
                _difference_max * a) /
                _math
            ) * _math;
          state.data.brightness_max_data.push(_max);
        }
        // state.brightness_max = state.brightness_max_data[0];
        state.data.brightness_max_data = state.data.brightness_max_data.filter(
          function (ele, pos) {
            return state.data.brightness_max_data.indexOf(ele) == pos;
          }
        );
        if (state.data.brightness_max_start == 0) {
          state.data.brightness_max_start = state.data.brightness_max_data[0];
        } else if (
          state.data.brightness_max_start >
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ] &&
          !state.data.brightness_max_max
        ) {
          state.data.brightness_max_start =
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ];
        } else if (
          state.data.brightness_max_start >
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ] &&
          state.data.brightness_max_max &&
          state.data.brightness_max_start != state.data.bright_max
        ) {
          state.data.brightness_max_start =
            state.data.brightness_max_data[
              state.data.brightness_max_data.length - 1
            ];
        }
        state.data.bright_max = state.data.APICalibrationData['brightness_max'];
        state.data.bright_min = state.data.APICalibrationData['brightness_min'];
        state.data.brightness_max_max =
          state.data.APICalibrationData['brightness']['SDR']['max'];
        state.data.brightness_max_min =
          state.data.APICalibrationData['brightness']['SDR']['min'];
        state.data.brightness_max_step =
          state.data.APICalibrationData['brightness']['SDR']['step'];
        // if (state.data.APICalibrationData['color_temperature']['SDR']['fix']) {
        //   state.data.temperature_lock = true;
        //   state.data.temperature_start =
        //     state.data.APICalibrationData['color_temperature']['SDR']['fix'] /
        //     100;
        //   _difference_max = (10000 - 4000) / 6;
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.data.temperature_data.push(_max / 100);
        //   }
        //   state.data.temperature_data = state.data.temperature_data.filter(
        //     function (ele, pos) {
        //       return state.data.temperature_data.indexOf(ele) == pos;
        //     }
        //   );
        // } else 
        if (
          state.data.APICalibrationData['color_temperature']['step']
        ) {
          state.data.temperature_lock = false;
          _difference_max =
            (state.data.APICalibrationData['color_temperature'][
              'range_max'
            ] -
              state.data.APICalibrationData['color_temperature'][
                'range_min'
              ]) /
            6;
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (
              state.data.APICalibrationData['color_temperature'][
                'range_min'
              ] /
                100 <
              1
            ) {
              _math = 10;
            }
            _max =
              Math.round(
                (state.data.APICalibrationData['color_temperature'][
                  'range_min'
                ] +
                  _difference_max * a) /
                  _math
              ) * _math;
            state.data.temperature_data.push(_max / 100);
          }
          state.data.temperature_data = state.data.temperature_data.filter(
            function (ele, pos) {
              return state.data.temperature_data.indexOf(ele) == pos;
            }
          );
          if (state.data.temperature_start == 0) {
            state.data.temperature_start = state.data.temperature_data[0];
          } else if (
            state.data.temperature_start >
            state.data.temperature_data[state.data.temperature_data.length - 1]
          ) {
            state.data.temperature_start =
              state.data.temperature_data[
                state.data.temperature_data.length - 1
              ];
          } else if (
            state.data.temperature_start < state.data.temperature_data[0]
          ) {
            state.data.temperature_start = state.data.temperature_data[0];
          }
        }
      }
    };
    const onChangeEotf = () => {
      // 可能有問題，與calibration行為不一致，不知道是需求還是什麼
      const _target =
        state.data.target_op[
          state.data.target_op
            .map((x) => x.text)
            .indexOf(state.data.target.text)
        ];
      if (_target == undefined) {
        state.data.brightness_max_start = 0;
        state.data.brightness_min_start = 0;
        state.data.temperature_start = 0;
        state.data.gamma_start = 0;
        state.data.coordinate['x'] = state.data.coordinateEnum['x']['default'];
        state.data.coordinate['y'] = state.data.coordinateEnum['y']['default'];
      } else {
        if (!_target['eotf'] || _target['eotf'] != state.data.EOTF.text) {
          // state.target = state.target_op[0];
          state.data.target.text = 'Customized';
          state.data.brightness_max_start = 0;
          state.data.brightness_min_start = 0;
          state.data.temperature_start = 0;
          state.data.gamma_start = 0;
        }
        if (_target['coordinate']) {
          state.data.coordinate['x'] = _target.coordinate['x']['default'];
          state.data.coordinate['y'] = _target.coordinate['y']['default'];
        }
      }
      setLineBar();
    };
    const onChangeTarget = () => {
      const _target =
        state.data.target_op[
          state.data.target_op
            .map((x) => x.text)
            .indexOf(state.data.target.text)
        ];
      if (state.data.target['val'] == '5') {
        //DICOM
        state.data.showGamutSelect = true;
        state.data.dicomGamut = state.data.dicomSelect_op[0];
        state.data.gamut = state.data.dicomGamut['text'];
        // state.data.gamut =
      } else {
        state.data.showGamutSelect = false;
        state.data.gamut = _target['gamut'];
      }

      if (state.data.target['val'] == '3') {
        //DCI-P3  target 要改預設用 x,y座標
        state.data.whitePointSelect = 'coordinate';
      } else {
        state.data.whitePointSelect = 'colorTemperature';
      }

      let _eotf;
      if (_target['eotf']) {
        for (let a = 0; a < state.data.EOTF_op_default.length; a++) {
          if (state.data.EOTF_op_default[a]['sub']) {
            for (
              let b = 0;
              b < state.data.EOTF_op_default[a]['sub'].length;
              b++
            ) {
              if (
                _target['eotf'] == state.data.EOTF_op_default[a]['sub'][b].text
              ) {
                state.data.EOTF = state.data.EOTF_op_default[a]['sub'][b];
                _eotf = state.data.EOTF_op_default[a]['sub'][b];
              }
            }
          }
          console.log('_target', _target['color_range']);
          if (state.data.EOTF_op_default[a].text == _target['color_range']) {
            state.data.EOTF_op = state.data.EOTF_op_default[a]['sub'];
          }
        }
      }
      if (_target['brightness']) {
        state.data.brightness_max_start = _target['brightness'];
      } else {
        state.data.brightness_max_start = 0;
      }
      if (_target['brightness_min']) {
        state.data.brightness_min_start = _target['brightness_min'];
      } else {
        state.data.brightness_min_start = -1;
      }
      if (_target['color_temperature']) {
        state.data.temperature_start = _target['color_temperature'] / 100;
      } else {
        state.data.temperature_start = 0;
      }
      // console.log(_target)
      if (_target['gamma']) {
        state.data.gamma_start = _target['gamma'];
      } else {
        state.data.gamma_start = 0;
      }

      if (_target['coordinate']) {
        state.data.coordinate.x = _target['coordinate']['x']['default'];
        state.data.coordinate.y = _target['coordinate']['y']['default'];
      }

      if (_eotf == state.data.EOTF) {
        setLineBar();
      } else if (_eotf) {
        state.data.EOTF = _eotf;
      }
    };

    const onChangeModifyRadio = (e) => {
      state.data.whitePointDisable = e == 'colorTemperature' ? 2 : 1;
    };

    const saveModifyData = () => {
      submitModal(state.data);
    };

    const changeInt = () => {
      coordinate_change(state.data.coordinate);
    };

    //deivce device

    const leaveAdvanced = () => {
      store.commit('setModalOutput', state.data);
      closeModal(BTN.CONFIRM);
    };

    const continueAdvanceBrightnessLimit = () => {
      closeModal(BTN.CONFIRM);
    };
    // watch( //state.group
    //   () => state.save_customized_name, async () => {
    //     if (state.data.target) {
    //       var _target = state.data.target.map(x => x.text).indexOf(state.save_customized_name);
    //       if (_target != -1 || state.save_customized_name == "") {
    //         state.save_customized_error = true;
    //       } else {
    //         state.save_customized_error = false;
    //       }
    //     }
    //   }
    // )
    watch(
      //state.group
      () => calibration_data.group,
      async () => {
        // console.log(calibration_data.group)
        getAPITablesData();
      }
    );
    watch(
      //state.device
      () => calibration_data.device,
      () => {
        // console.log(calibration_data.device)
        getAPITablesData();
      }
    );
    //#endregion

    const _changePrvacyTxt = (lang) => {
      const _lang = lang;

      const euCountries = [
        'de',
        'nl',
        'fr',
        'enno',
        'it',
        'pl',
        'ro',
        'es',
        'sv',
        'turkish',
        'dutch',
        'french',
        'german',
        'italian',
        'polish',
        'romanian',
        'spanish',
        'swedish',
        'ukrainian',
      ];
      const isEuCountry = euCountries.includes(_lang);

      if (_lang == LANG.TW) {
        // todo 沒有放在string table裏
        __popup.__asusPrivacyNoticeTitle = '華碩提醒您';
        __popup.__asusPrivacyNoticeTitleDesc1 = `歡迎使用華碩ASUS ${brandDisplayTxt} Color Center 網站(以下稱「本網站」)！敬請您詳細閱讀以下事項：`;
        __popup.__asusPrivacyNoticeTitleDesc2 = '請詳閱以下華碩隱私權聲明：';
        __popup.__asusPrivacyNoticePart1Title = '華碩隱私權聲明';
        __popup.__asusPrivacyNoticePoint1_text = `為了協助您遠端管理、調整、控制華碩 ${brandDisplayTxt} 顯示器的色彩、改善及提升華碩產品及服務，以開發、評估華碩的新服務及新功能，當您點選以下<同意>按鍵，華碩將可能透過本網站蒐集您所同意的下述資料：`;
        __popup.__asusPrivacyNoticePoint1_data = `您所上傳的華碩${brandDisplayTxt} 顯示器的產品序號；您對華碩${brandDisplayTxt} 顯示器的色彩校正設定、管理相關資訊，例如群組的名稱、色彩校正的排程資訊、您所設定的色彩空間(color space)標準、色域、亮度、色溫、電光轉換函數(Electro-Optical Transfer Function)及外接式校色器的類型；您所輸入的色彩參數資訊。`;
        __popup.__asusPrivacyNoticePoint1_note = `惠請知悉：以上資料為華碩為了提供您遠端管理、調整、控制華碩${brandDisplayTxt} 顯示器的色彩所必要蒐集之資料。若您點選以下<不同意>按鍵或至第四段的路徑關閉傳送以上資料至華碩，本軟體將可能無法正常運作，敬請見諒。`;
        __popup.__asusPrivacyNoticePoint2_text = `為了進行上述遠端服務，您須將您在本網站的使用者帳號與某台華碩${brandDisplayTxt} 顯示器進行綁定。綁定完成後，當您登入本網站時，將會看到該台${brandDisplayTxt} 顯示器的使用者產品資料，並可遠端對該${brandDisplayTxt} 顯示器進行色彩調整。若該位使用者並未同意您使用他/她的資料，請勿進行綁定。綁定流程請參考使用手冊。`;
        __popup.__asusPrivacyNoticePoint3_title = '註冊會員：';
        __popup.__asusPrivacyNoticePoint3_text = '在您登入本軟體之前，本軟體會請您事先註冊ASUS/ ROG帳號。關於ASUS/ ROG帳號的註冊說明，請參考ASUS/ ROG帳號的註冊介面或網站。';
        __popup.__asusPrivacyNoticePoint4_text = '華碩十分尊重您的個人隱私和權益，您可以透過以下方式來開啟或關閉傳送以上資料至華碩 : 資訊 > 隱私權政策；進一步了解華碩如何保護您的隱私，亦建議您造訪';
        __popup.__asusPrivacyNoticePoint4_link = '華碩隱私權政策';

        __popup.__asusEUDataActNoticePart2Title = '';
        __popup.__asusEUDataActNoticeIntro = '';
        __popup.__asusEUDataActNoticePoint1_title = '';
        __popup.__asusEUDataActNoticePoint1_1 = '';
        __popup.__asusEUDataActNoticePoint1_2 = '';
        __popup.__asusEUDataActNoticePoint1_3 = '';
        __popup.__asusEUDataActNoticePoint2_title = '';
        __popup.__asusEUDataActNoticePoint3_title = '';
        __popup.__asusEUDataActNoticePoint3_1 = '';
        __popup.__asusEUDataActNoticePoint3_2 = '';
        __popup.__asusEUDataActNoticePoint4_title = '';
        __popup.__asusEUDataActNoticePoint4_1_pre = '';
        __popup.__asusEUDataActNoticePoint4_1_link_text = '';
        __popup.__asusEUDataActNoticePoint4_1_post = '';
      } else {
        if (isEuCountry) {
          __popup.__asusPrivacyNoticeTitle = 'ASUS Privacy Notice / ASUS EU Data Act Notice';
          __popup.__asusPrivacyNoticeTitleDesc1 = `Welcome to use ASUS ${brandDisplayTxt} Color Center website ("this Website")!`;
          __popup.__asusPrivacyNoticeTitleDesc2 = 'Please find the below details of ASUS Privacy Notice (Part 1) and ASUS EU Data Act Notice (Part 2):';
          __popup.__asusPrivacyNoticePart1Title = 'Part 1: ASUS Privacy Notice';
          __popup.__asusPrivacyNoticePoint1_text = `In order to remotely manage, adjust and control the color of ASUS ${brandDisplayTxt} monitors ("Monitor"), assess and improve ASUS products and services, and to develop and evaluate new products and services of ASUS, by clicking on "I agree" below, you agree to provide the following information with ASUS:`;
          __popup.__asusPrivacyNoticePoint1_data = 'Serial number of Monitor; calibration history, settings and management information of Monitor, such as group name, calibration schedule, standard of color space, color gamut, brightness, color temperature, EOTF (Electro-Optical Transfer Function) and type of external calibration unit.';
          __popup.__asusPrivacyNoticePoint1_note = 'Please note that: The above data is necessary for ASUS to provide you with the functions of remote management, adjustment and control for the color of Monitor. If you click on "I do not agree" button below or disable sharing the above data with ASUS through the route mentioned in the 4ᵗʰ paragraph, this Website may not work normally. We apologize for the inconvenience this may cause.';
          __popup.__asusPrivacyNoticePoint2_text = 'To use the remote service, you need to bind your user account of this Website with a Monitor. You may access to the product and log information of the Monitor, and proceed with color calibration on it. If the user of Monitor does not agree to share data with you, please do not start with the binding process. Please refer to the user manual to see the details of account binding.';
          __popup.__asusPrivacyNoticePoint3_title = 'Member registration:';
          __popup.__asusPrivacyNoticePoint3_text = 'Before you start to use this Website, please register and login to ASUS/ ROG Account. Regarding how to register for an ASUS/ ROG Account, please refer to the registration interface or website of ASUS/ ROG Account.';
          __popup.__asusPrivacyNoticePoint4_text = 'ASUS is committed to protecting and respecting your privacy; you may visit Information> Privacy to enable/disable sharing the above with ASUS at all times. To know more about how ASUS protects your privacy, please visit';
          __popup.__asusPrivacyNoticePoint4_link = 'ASUS\' Privacy Policy/ ASUS EU Data Act Policy.';
        } else {
          __popup.__asusPrivacyNoticeTitle = 'ASUS NOTICE';
          __popup.__asusPrivacyNoticeTitleDesc1 = `Welcome to use ASUS ${brandDisplayTxt} Color Center website ("this Website")! Please read the following notice carefully:`;
          __popup.__asusPrivacyNoticeTitleDesc2 = 'Please find the below details of ASUS Privacy Notice:';
          __popup.__asusPrivacyNoticePart1Title = 'ASUS Privacy Notice';
          __popup.__asusPrivacyNoticePoint1_text = `In order to remotely manage, adjust and control the color of ASUS ${brandDisplayTxt} monitors ("Monitor"), assess and improve ASUS products and services, and to develop and evaluate new products and services of ASUS, by clicking on "I agree" below, you agree to provide the following information with ASUS:`;
          __popup.__asusPrivacyNoticePoint1_data = 'Serial number of Monitor; calibration history, settings and management information of Monitor, such as group name, calibration schedule, standard of color space, color gamut, brightness, color temperature, EOTF (Electro-Optical Transfer Function) and type of external calibration unit.';
          __popup.__asusPrivacyNoticePoint1_note = 'Please note that: The above data is necessary for ASUS to provide you with the functions of remote management, adjustment and control for the color of Monitor. If you click on "I do not agree" button below or disable sharing the above data with ASUS through the route mentioned in the 4ᵗʰ paragraph, this Website may not work normally. We apologize for the inconvenience this may cause.';
          __popup.__asusPrivacyNoticePoint2_text = 'To use the remote service, you need to bind your user account of this Website with a Monitor. You may access to the product and log information of the Monitor, and proceed with color calibration on it. If the user of Monitor does not agree to share data with you, please do not start with the binding process. Please refer to the user manual to see the details of account binding.';
          __popup.__asusPrivacyNoticePoint3_title = 'Member registration:';
          __popup.__asusPrivacyNoticePoint3_text = 'Before you start to use this Website, please register and login to ASUS/ ROG Account. Regarding how to register for an ASUS/ ROG Account, please refer to the registration interface or website of ASUS/ ROG Account.';
          __popup.__asusPrivacyNoticePoint4_text = 'ASUS is committed to protecting and respecting your privacy; you may visit Information> Privacy to enable/disable sharing the above with ASUS at all times. To know more about how ASUS protects your privacy, please visit';
          __popup.__asusPrivacyNoticePoint4_link = 'ASUS\' Privacy Policy';
        }
        
        if (isEuCountry) {
          __popup.__asusEUDataActNoticePart2Title = 'Part 2: ASUS EU Data Act Notice (For EU products)';
          __popup.__asusEUDataActNoticeIntro = 'During your use of this Software, your data ("Product Data") in connection with this ASUS Monitor ("Connected Product") governed by the EU Data Act may be generated. As required under Article 3 (2) of EU Data Act, please refer to the details below about your Product Data:';
          __popup.__asusEUDataActNoticePoint1_title = 'Information about type, format and estimated volume of Product Data:';
          __popup.__asusEUDataActNoticePoint1_1 = '(1)	The Connected Product generates the following type(s) of the Product Data: Data mentioned in Paragraph 1 in the above Part 1 ASUS Privacy Notice';
          __popup.__asusEUDataActNoticePoint1_2 = '(2)	Product Data is available in the following format(s): csv';
          __popup.__asusEUDataActNoticePoint1_3 = '(3)	Estimated volume of the Product Data: 100 bytes/ per data';
          __popup.__asusEUDataActNoticePoint2_title = 'Information about whether the Connected Product is capable of generating the Product Data continuously and in real-time: Yes';
          __popup.__asusEUDataActNoticePoint3_title = 'Information about whether the Connected Product is capable of storing the Product Data on-device or on a remote server, including, where applicable, the intended duration of retention:';
          __popup.__asusEUDataActNoticePoint3_1 = '(1)	The Connected Product is capable of storing the Product Data on server.';
          __popup.__asusEUDataActNoticePoint3_2 = '(2)	Product Data is stored until you instruct us to delete it.';
          __popup.__asusEUDataActNoticePoint4_title = 'Information about how the user may access, retrieve or, where relevant, erase the Product Data, including the technical means to do so, as well as their terms of use and quality of service:';
          __popup.__asusEUDataActNoticePoint4_1_pre = '(1) The user can access, retrieve and erase the Product Data by by submitting an application at "';
          __popup.__asusEUDataActNoticePoint4_1_link_text = 'Customer\'s Request on Personal Data';
          __popup.__asusEUDataActNoticePoint4_1_post = '" interface on ASUS official website.';
        } else {
          __popup.__asusEUDataActNoticePart2Title = '';
          __popup.__asusEUDataActNoticeIntro = '';
          __popup.__asusEUDataActNoticePoint1_title = '';
          __popup.__asusEUDataActNoticePoint1_1 = '';
          __popup.__asusEUDataActNoticePoint1_2 = '';
          __popup.__asusEUDataActNoticePoint1_3 = '';
          __popup.__asusEUDataActNoticePoint2_title = '';
          __popup.__asusEUDataActNoticePoint3_title = '';
          __popup.__asusEUDataActNoticePoint3_1 = '';
          __popup.__asusEUDataActNoticePoint3_2 = '';
          __popup.__asusEUDataActNoticePoint4_title = '';
          __popup.__asusEUDataActNoticePoint4_1_pre = '';
          __popup.__asusEUDataActNoticePoint4_1_link_text = '';
          __popup.__asusEUDataActNoticePoint4_1_post = '';
        }
      } //end: else

      switch (_lang) {
        case LANG.TW:
          __popup.__EULA = EULA.TW;
          break;
        case LANG.EN:
          __popup.__EULA = EULA.EN;
          break;
        case LANG.JP:
          __popup.__EULA = EULA.JP;
          break;
        case LANG.FRE:
          __popup.__EULA = EULA.FRE;
          break;
        case LANG.GER:
          __popup.__EULA = EULA.GER;
          break;
        case LANG.SPAN:
          __popup.__EULA = EULA.SPAN;
          break;
        default:
          __popup.__EULA = EULA.EN;
          break;
      }
    }; //end: _changePrvacyTxt

    _changePrivacyLink(locale.value);
    _changePrvacyTxt(locale.value);

    return {
      state,
      storeState,
      closeModal,
      handleModalContent,
      submitModal,
      sumbitTestModal,
      cancelTestModal,
      subGroupAdd,
      POPUP,
      btnMainStyleEnable,
      contactModal,
      tableSortDevi,
      onCheckAllDevi,
      onCheckEachDevi,
      goTableLinkDevi,
      groupVal,
      showCTAndRowDevi,
      submitContactus,
      globalAddDeviceModal,
      btnMainStyleFull,
      btnBorderMainStyleFull,
      btnBorderMainStyleEnable,
      onClickGlobalDeviceTab,
      Detial_icon,
      chose_devices,
      chose_devices_all,
      send_customized,
      showCTAndRow,
      goTableLink,
      onCheckEach,
      onCheckAll,
      tableSort,
      licenseModal,
      onClickLicenseTab,
      importCVSModal,
      unGroup,
      getTasks,
      editApp,
      groupNameClose,
      apiAllNameList,
      tableSortDeviceAdd,
      modalDeviceList,
      selectChange,
      addDeviceToGroup,
      calibration_data,
      close_customized,
      cleanContactForm,
      finshTimer,
      generateCode,
      closeGlobalAddDevice,
      resetProfile,
      tableFilter,
      saveCustomized,
      brightness_max_change,
      brightness_min_change,
      temperature_change,
      gamma_change,
      setLineBar,
      onChangeEotf,
      onChangeTarget,
      saveModifyData,
      btnDefault,
      skipCustomized,
      uploadCSV,
      csvUploadBtn,
      uploadCSVFile,
      sortCSVData,
      onCheckAllCSV,
      onCheckEachCSVData,
      onSubmitCSVDeviceAdd,
      onChangeFilter,
      csvCheckTotal,
      onClickDownloadCSV,
      onPrivacySumbit,
      onEULAubmit,
      isCSVBtnCancel,
      tableSortDashboard,
      getDashboardDetail,
      leaveAdvanced,
      golicenseLink,
      goDashboardTaskLink,
      callBackAddDevice,
      t,
      importCVSModal_columns,
      licenseModal_columns,
      webLicense,
      onCloseLicense,
      privacyLink,
      pcLicense,
      ERRORDESC,
      gamutOnChange,
      copyInviteCode,
      continueAdvanceBrightnessLimit,
      changeInt,
      onChangeModifyRadio,
      modalTableScrollHeight,
      chose_group,
      tableSortGroup,
      chose_groups_all,
      close_customized_group,
      send_customized_group,
      groupError,
      __popup,
      transferDepictionCodeForMessage,
      addDeviceBtnText,
      brand,
    };
  },
};
